import { useAuth } from '@teko/auth-react';
import { useTenantConfig } from 'contexts';

export const useRequireLoginForCartAction = () => {
  const { user, authService } = useAuth();
  const { epicOmni1825 } = useTenantConfig();

  return () => {
    if (!!epicOmni1825 && !user?.userId) {
      authService.login(window.location.href);
      return true;
    }
    return false;
  };
};
